module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


//////////////////
// WEBPACK FOOTER
// ./~/htmlparser2/~/entities/maps/xml.json
// module id = 420
// module chunks = 1 4 5 6 8 9 10 12 13 14 19 21 24 27 28 57